import { render, staticRenderFns } from "./CertForm.vue?vue&type=template&id=7f203508&scoped=true"
import script from "./CertForm.vue?vue&type=script&lang=js"
export * from "./CertForm.vue?vue&type=script&lang=js"
import style0 from "./CertForm.vue?vue&type=style&index=0&id=7f203508&prod&lang=scss"
import style1 from "./CertForm.vue?vue&type=style&index=1&id=7f203508&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f203508",
  null
  
)

export default component.exports